'use client';
import DistribuidoraSection from './static-sections/DistribuidoraSection';
import HistoriaSection from './static-sections/HistoriaSection';
import Footer from './static-sections/Footer';
import DynamicSections from './dynamic-sections/DynamicSections';
import MainHedaer from './static-sections/MainHeader';
import LibreriaSection from './static-sections/LibreriaSection';

const Home = () => {
  return (
    <div>
      <MainHedaer />
      <DynamicSections />
      <LibreriaSection />
      <DistribuidoraSection />
      <HistoriaSection />
      <Footer />
    </div>
  );
};

export default Home;
